import { Box } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { initializeStudy } from "redux/reducers/studyReducer"
import FormsTable from "../FormsTable"
import { initializeFormsByPatient } from "redux/reducers/patientFormsReducer"

const DisplayPatientForm = () => {
  const patientId = useSelector(({ patient }) => patient.id);
  const centerId = useSelector(({ center }) => center)?.data?.id
  const formsByPatient = useSelector(({ formsByPatient }) => formsByPatient)
  const selectedCenterStudyId = useSelector(({ center }) => center)?.data?.studyId
  const { data: studyData } = useSelector(({ study }) => study)

  const dispatch = useDispatch()

  useEffect(() => {
    if (centerId && formsByPatient.data?.length === 0) {
      dispatch(initializeFormsByPatient(patientId))
    }
  }, [centerId, dispatch])


  useEffect(() => {
    if (selectedCenterStudyId && !studyData) {
      dispatch(initializeStudy(selectedCenterStudyId))
    }
  }, [selectedCenterStudyId, studyData, dispatch])

  if (!formsByPatient) return null;

  return (
    <Box sx={{ minWidth: "100%" }}>
      {centerId && <FormsTable entityId={centerId} formsConfig={formsByPatient}  />}
    </Box>
  )
}

export default DisplayPatientForm
